import { Base } from "../../framework/base";
import { EditItem, IEditItem } from "../common/editItem";
import { FileAttachment, IFileAttachment } from "../common/fileAttachment";
import { CalendarTaskRepetitionType, CalendarTaskState, DatabaseRecordType } from "../enums";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface ICalendarTaskEditItem extends IEditItem {
    parentId: string; //nullable
    companyId: string;
    categoryId: string;
    recordId: string;
    databaseRecordType: DatabaseRecordType; //nullable
    state: CalendarTaskState;
    title: string;
    locationText: string;
    description: string;
    startDate: number;
    endDate: number; //nullable
    allDay: boolean;
    isPrivate: boolean;
    isRead: boolean;
    hasChildren: boolean;
    remainder: number; //-1 = No in use, 0 => n = minutes before start time
    repetitionIntervalType: CalendarTaskRepetitionType;
    repetitionInterval: number; // n = Every n week/month/year
    repetitionIntervalSub: number; //1010001 = Mon, Wed, Sun, 23 = 23rd of Month, 1224 = 24th of December
    repetitionEndRepeatCount: number; //n = End after n repeats (null/0 = use repetition end date)
    repetitionEndDate: number; //d = End after date d (null = use repetition end repeat count)
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    lockedUser: IModifyUser;
    handlers: IModifyUser[];
    attachments: IFileAttachment[];

    isLockedToOtherUser(userCode: string): boolean;
}

export class CalendarTaskEditItem extends EditItem implements ICalendarTaskEditItem {
    parentId: string; //nullable
    companyId: string;
    categoryId: string;
    recordId: string;
    databaseRecordType: DatabaseRecordType; //nullable
    state: CalendarTaskState;
    title: string;
    locationText: string;
    description: string;
    startDate: number;
    endDate: number; //nullable
    allDay: boolean;
    isPrivate: boolean;
    isRead: boolean;
    hasChildren: boolean;
    remainder: number; //-1 = No in use, 0 => n = minutes before start time
    repetitionIntervalType: CalendarTaskRepetitionType;
    repetitionInterval: number; // n = Every n week/month/year
    repetitionIntervalSub: number; //1010001 = Mon, Wed, Sun, 23 = 23rd of Month, 1224 = 24th of December
    repetitionEndRepeatCount: number; //n = End after n repeats (null/0 = use repetition end date)
    repetitionEndDate: number; //d = End after date d (null = use repetition end repeat count)
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    lockedUser: ModifyUser;
    handlers: ModifyUser[];
    attachments: FileAttachment[];

    constructor();
    constructor(obj: ICalendarTaskEditItem);
    constructor(obj?: any) {
        super(obj);
        this.parentId = obj && obj.parentId || "";
        this.companyId = obj && obj.companyId || "";
        this.categoryId = obj && obj.categoryId || "";
        this.recordId = obj && obj.recordId || "";
        this.databaseRecordType = obj?.databaseRecordType;
        this.state = obj && obj.state || CalendarTaskState.NotStarted;
        this.title = obj && obj.title || "";
        this.locationText = obj && obj.locationText || "";
        this.description = obj && obj.description || "";
        this.startDate = obj && obj.startDate || 0;
        this.endDate = obj?.endDate;
        this.allDay = obj && obj.allDay || false;
        this.isPrivate = obj && obj.isPrivate || false;
        this.isRead = obj && obj.isRead || false;
        this.hasChildren = obj && obj.hasChildren || false;
        this.remainder = -1;
        if (!Base.isNullOrUndefined(obj?.remainder)) {
            this.remainder = obj.remainder;
        }
        this.repetitionIntervalType = obj && obj.repetitionIntervalType || CalendarTaskRepetitionType.NotRepeated;
        this.repetitionInterval = obj && obj.repetitionInterval || 0;
        this.repetitionIntervalSub = this.repetitionIntervalType === CalendarTaskRepetitionType.Weekly
            ? 1000000
            : (this.repetitionIntervalType === CalendarTaskRepetitionType.Monthly
                ? 1
                : 101
            );
        if (!Base.isNullOrUndefined(obj?.repetitionIntervalSub)) {
            this.repetitionIntervalSub = obj.repetitionIntervalSub;
        }
        this.repetitionEndRepeatCount = obj && obj.repetitionEndRepeatCount || 0;
        this.repetitionEndDate = obj && obj.repetitionEndDate || 0;
        if (!this.repetitionEndDate && !this.repetitionEndRepeatCount && this.repetitionIntervalType !== CalendarTaskRepetitionType.NotRepeated) {
            this.repetitionEndRepeatCount = 1;
        }
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.lockedUser = obj?.lockedUser ? new ModifyUser(obj.lockedUser) : null;
        this.handlers = Base.getTypedArray(obj ? obj.handlers : null, ModifyUser);
        this.attachments = Base.getTypedArray(obj ? obj.attachments : null, FileAttachment);
    }

    isLockedToOtherUser(userCode: string): boolean {
        return this.lockedUser?.code && !userCode.equalIgnoreCase(this.lockedUser.code);
    }
}